// Reporting-period maths for evidence packs. Mirrors
// backend/evidence_packs.completed_calendar_period so the range a buyer sees in
// the form is the same one the backend validates against — computed, never
// hard-coded (on 25 Aug 2026, "last 6 completed calendar months" is
// 1 Feb 2026 to 31 Jul 2026).

const MONTHS = ["January", "February", "March", "April", "May", "June", "July",
  "August", "September", "October", "November", "December"];

/**
 * The N full calendar months immediately before the current month.
 * @returns {{start: Date, end: Date}} local dates.
 */
export function lastCompletedCalendarMonths(months, today = new Date()) {
  if (!Number.isInteger(months) || months < 1) throw new Error("months must be >= 1");
  const y = today.getFullYear();
  const m = today.getMonth(); // 0-indexed
  // Last day of the month before the current one.
  const end = new Date(y, m, 0); // day 0 of current month = last day of previous
  // First day of the month (months-1) before `end`'s month.
  const start = new Date(end.getFullYear(), end.getMonth() - (months - 1), 1);
  return { start, end };
}

function fmt(d) {
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

/** Human range, e.g. "1 February 2026 to 31 July 2026". */
export function periodLabel(months, today = new Date()) {
  const { start, end } = lastCompletedCalendarMonths(months, today);
  return `${fmt(start)} to ${fmt(end)}`;
}
